import { render } from "./Pedagogico.vue?vue&type=template&id=e2f5821c"
import script from "./Pedagogico.vue?vue&type=script&lang=js"
export * from "./Pedagogico.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__